import Vue from "vue";
import { debounce } from 'lodash';

Vue.component("proposed-modification-autocomplete", {
    props: ["value",
        "language",
        "disabled",
        "isActive",
        "placeholder",
        "isObjection",
        "showModifyingParty",
        "modifyingParty"
    ],
    data() {
        return {
            isFetching: false,
            data: [],
            parties: [],
            selected: null,
            myValue: null,
            isDisabled: this.disabled,
            modifyingPartyLabel: window.labels.modifyingParty,
            isFetchingParty: false,
            selectedParty: null
        };
    },
    watch: {
        selected: function (val) {
            if (val) {
                if (val.id != this.value) {
                    this.$emit("update:value", val.id);
                }
            }
        },
        selectedParty: function (val){
            if (val) {
                console.log(val)
                if (val !== this.modifyingParty) {
                    this.$emit("update:modifyingParty", val);

                }

            }
            this.$services.proposedModificationNotifications.getAutocomplete({
                language: this.language,
                isActive: this.isActive,
                isObjection: this.isObjection,
                partyId: this.selectedParty
            })
                .then((data) => {
                    this.data = []
                    if (data.items) {
                        data.items.forEach((item) => this.data.push(item))
                    }
                    this.isFetching = false;
                });
        }
    },
    methods: {
        getParties: function(){
            this.isFetchingParty     = true;
            this.$services.parties.getDropdownItems({
                language: this.language,
                includeWto: false,
                published: true
            }).then((data) => {
                
                this.isFetchingParty = false;
                this.parties = data;
        
            });
        },
        getAsyncData: debounce(function (query) {
            //if (!query.length) {
            //    this.data = []
            //    return
            //}

            this.isFetching = true;

            this.$services.proposedModificationNotifications.getAutocomplete({
                language: this.language,
                query: query,
                isActive: this.isActive,
                isObjection: this.isObject
            })
                .then((data) => {
                    this.data = []
                    if (data.items) {
                        data.items.forEach((item) => this.data.push(item))
                    }
                    this.isFetching = false;
                });
        }, 500)
    },
    mounted() {
        this.isFetching = true;
        this.getParties();
        if (this.value) {


            this.$services.proposedModificationNotifications.getAutocomplete({
                language: this.language,
                id: this.value
            })
                .then((data) => {
                    this.data = []
                    if (data.items) {


                        data.items.forEach((item) => this.data.push(item))
                        console.log(data.items[0].documentSymbol)
                        this.myValue = data.items[0].documentSymbol;
                    }

                });

            this.$services.proposedModificationNotifications.getAutocomplete({
                language: this.language,
                isActive: this.isActive,
                isObjection: this.isObjection,
                partyId: this.selectedParty
            })
                .then((data) => {
                    this.data = []
                    if (data.items) {
                        data.items.forEach((item) => this.data.push(item))
                    }
                    this.isFetching = false;
                });
        } else {
            this.$services.proposedModificationNotifications.getAutocomplete({
                language: this.language,
                isActive: this.isActive,
                isObjection: this.isObjection,
                partyId: this.selectedParty
            })
                .then((data) => {
                    this.data = []
                    if (data.items) {
                        data.items.forEach((item) => this.data.push(item))
                    }
                    this.isFetching = false;
                });
        }
    },
    template: `
      <div>
        <b-field grouped>
          <b-field label-position="on-border" :label="modifyingPartyLabel">
            <b-select v-model="selectedParty" v-if='showModifyingParty' :loading="isFetchingParty"
                      :placeholder="modifyingPartyLabel">
              <option v-for='party in parties' :value='party.id'>{{ party.text }}</option>
            </b-select>
          </b-field>
          <b-field expanded label-position="on-border" label="Document Symbol">
            <b-autocomplete
              v-model="myValue"
              :data="data"
              :placeholder="placeholder"
              field="documentSymbol"
              :loading="isFetching"
              @typing="getAsyncData"
              clearable
              :disabled="isDisabled"
              open-on-focus
              @select="option => selected = option"
              >

              <template slot-scope="props">
                <div class="media">

                  <div class="media-content">
                    {{ props.option.documentSymbol }}
                    <br>
                    <small>
                      Title:{{ props.option.title }}<br/>
                      Party:{{ props.option.countryName }}
                    </small>
                  </div>
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </b-field>
      </div>
    `
});